function userRechargeType() {
  var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!(info !== null && info !== void 0 && info.id)) {
    return "";
  }
  var obj = {
    label: "",
    type: 0,
    color: 'warning'
  };
  var user_type = info.user_type,
    user_type_status = info.user_type_status,
    user_type_account_status = info.user_type_account_status;
  if (user_type === 3) {
    if (user_type_account_status === 1 && user_type_status === 3) {
      obj.label = "季度用户";
      obj.type = 1;
      obj.color = 'warning';
    } else if (user_type_account_status === 2 && user_type_status === 3) {
      obj.label = "季度过期";
      obj.type = 2;
      obj.color = 'danger';
    } else {
      obj.label = "季度待上线";
      obj.type = 3;
      obj.color = 'warning';
    }
  } else if (user_type === 1) {
    if (user_type_account_status === 1 && user_type_status === 3) {
      obj.label = "充值用户";
      obj.type = 4;
      obj.color = 'warning';
    } else if (user_type_account_status === 2 && user_type_status === 3) {
      obj.label = "充值欠费";
      obj.type = 5;
      obj.color = 'danger';
    } else {
      obj.label = "充值待上线";
      obj.type = 6;
      obj.color = 'warning';
    }
  }
  return obj;
}
export { userRechargeType };